const POTENTIAL_PAYOUT_ROUTE = 'potential-payout';
const GET_POTENTIAL_PAYOUT_ROUTE = 'get-potential-payout';
const ORIGINAL_POTENTIAL_PAYOUT_ROUTE = 'get-original-potential-payout';
const POTENTIAL_PAYOUT_SYSTEM_ROUTE = 'get-potential-payout-system';

export {
    POTENTIAL_PAYOUT_ROUTE,
    ORIGINAL_POTENTIAL_PAYOUT_ROUTE,
    GET_POTENTIAL_PAYOUT_ROUTE,
    POTENTIAL_PAYOUT_SYSTEM_ROUTE,
};
